/**
* Deep nested object helper
*
* @param {object} p - path
* @param {object} o - items to check
* @param {Object} d - default value
*/
export const get = (p, o, d=null) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : d, o);


// WEBPACK FOOTER //
// ./src/helpers/objectHelper.js